import type { ReactNode } from "react";

/**
 * Единая ширина контента для публичных страниц. Совпадает с шириной глобальных
 * хлебных крошек (max-w-7xl), поэтому шапка, контент и крошки стоят на одной
 * вертикали. Для длинных текстов внутри используйте max-w-3xl.
 */
export default function PageContainer({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={`mx-auto w-full max-w-7xl px-4 ${className}`}>{children}</div>;
}
